import React from 'react';
import { Link } from 'react-router-dom';

class Field2 extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        return (
            <div>
                <div className="container g-pt-140 g-pb-20">
                    <div className="u-heading-v3-1 g-brd-bottom g-brd-gray-light-v3 g-pt-20">
                        <h2 className="h3 u-heading-v3__title g-brd-primary g-brd-bottom-2--md g-font-size-22 g-font-weight-600 g-line-height-0_9">교육현장과 동물</h2>
                        <ul className="g-hidden-xs-down u-list-inline pull-right g-pt-2 g-font-size-13">
                            <li className="list-inline-item g-mr-5 g-hidden-xs-down">
                                <Link to="/" className="u-link-v5 g-color-main">Home</Link>
                            </li>
                            <li className="list-inline-item g-mr-5">
                                <i className="g-color-gray-light-v2 g-mr-5">/</i>
                                <Link to="/home/about" className="u-link-v5 g-color-main">카라교육</Link>
                            </li>
                            <li className="list-inline-item g-color-primary"><i className="g-color-gray-light-v2 g-mr-5">/</i>교육현장과 동물</li>
                        </ul>
                    </div>
                </div>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 g-pb-10">

                            <ul className="nav nav-justified u-nav-v2-1 u-nav-primary g-mt-20 g-mb-40">
                                <li className="nav-item"><Link to="/home/field" className="nav-link g-brd-gray-light-v4 g-font-size-16">교실 속 동물들</Link></li>
                                <li className="nav-item"><Link to="#!" className="nav-link g-brd-gray-light-v4 g-font-size-16 active">학교동물 보호방법</Link></li>
                            </ul>

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h4 g-font-weight-600">꼭 필요한 실천</h3>
                                    <p className="g-line-height-2">동물복지에 대한 기준과 원칙을<br /> 고려한 교육 계획</p>
                                </div>
                                <div className="col-md-9">
                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>섣불리 동물을 키우지 않습니다</p>
                                    <ul className="list-unstyled g-pl-20 g-pb-15">
                                        <li> 교육적 이용 전후 동물의 삶에 대한 계획이 확실하지 않다면, 동물을 실내에서 가두어 키우는 것은 바람직하지 않습니다. 포유류 뿐 아니라 작은 곤충도 마찬가지입니다.</li>
                                    </ul>
                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>동물원 등 동물이 있는 곳을 방문한다면, 그곳의 동물복지를 미리 조사하고 결정합니다</p>
                                    <ul className="list-unstyled g-pl-20 g-pb-15">
                                        <li className="g-mb-10">1. 이동동물원을 부르지 않습니다!<br /> <span className="g-pl-15">동물에게 스트레스를 주고 괴롭히는 일에 참여하지 않습니다.</span></li>
                                        <li>2. 동물복지가 열악한 동물원은 가지 않습니다!<br /> <span className="g-pl-15">동물을 학대하는 곳에 소중한 교육비를 소비하지 않습니다.</span></li>
                                    </ul>

                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>동물보호교육을 실시합니다</p>
                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>관련정보가 필요할 경우 동물보호단체 등에 요청합니다</p>
                                </div>
                            </div>

                            <hr />

                            <div className="row">
                                <div className="col-md-3">
                                    <h3 className="h4 g-font-weight-600">더 할 수 있는 실천</h3>
                                    <p className="g-line-height-2">동물복지 증진을 위한<br /> 유의미한 실천</p>
                                </div>
                                <div className="col-md-9">
                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>채식단을 운영할 수 있습니다</p>
                                    <ul className="list-unstyled g-pl-20 g-pb-15">
                                        <li>식단에서 육고기 반찬을 줄이거나, 일주일에 1번 균형잡힌 채식단을 운영하여 영양과잉으로 인한 질병 문제를 예방하고 동물복지 증진에 기여합니다.</li>
                                    </ul>
                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>동물복지축산물을 이용할 수 있습니다</p>
                                    <ul className="list-unstyled g-pl-20 g-pb-15">
                                        <li>공장식 축산을 통해 고통받는 동물의 수를 줄이고, 동물복지축산을 통해 인도적 대우를 받는 동물의 수를 늘릴 수 있습니다.</li>
                                    </ul>
                                    <p className="mb-2"><i className="g-color-blue-gradient-opacity-v1 mr-2 fa fa-star"></i>주변의 동물을 배려할 수 있습니다</p>
                                    <ul className="list-unstyled g-pl-20 g-pb-15">
                                        <li>학교 주변에 도움이 필요한 동물이 있다면, 학교구성원들이 동물을 돕기 위해 함께 고민하고 실천할 수 있습니다.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Field2;


// WEBPACK FOOTER //
// ./src/pages/front/home/field2.js